import { useState } from "react";
import { isEmpty } from "lodash";
import I18n from "^/config/i18n";
import courseDetailsMapping from "^/utils/courseDetailsMapping";
import FilterItem from "./FilterItem";

export const Filter = ({ terms, updateTerms, scrollTo }) => {
  const [open, setOpen] = useState("initial");

  const FilterItems = () => (
    <div className={`filter-items row ${open !== "close" ? "pt-3" : "py-0"}`}>
      <FilterItem
        terms={terms}
        updateTerms={updateTerms}
        title={I18n.t("CourseOver degree")}
        values={{
          attr: "degree",
          items: ["bachelor", "master"],
        }}
        className="col-12"
        open={open === "initial" ? "open" : open}
      />

      <FilterItem
        terms={terms}
        updateTerms={updateTerms}
        title={I18n.t("CourseOver orientation")}
        values={{
          attr: "orientation",
          items: ["technology", "business", "informatics"],
        }}
        className="col-12"
        open={open === "initial" ? "close" : open}
      />

      <FilterItem
        terms={terms}
        updateTerms={updateTerms}
        title={I18n.t("CourseOver location")}
        values={{
          attr: "location",
          items: ["techcampus", "bildungscampus", "kuenzelsau", "schwaebisch"],
        }}
        className="col-12"
        open={open === "initial" ? "close" : open}
      />

      <FilterItem
        terms={terms}
        updateTerms={updateTerms}
        title={I18n.t("CourseOver start")}
        values={{
          attr: "start",
          items: ["summer", "winter"],
        }}
        className="col-12"
        open={open === "initial" ? "close" : open}
      />

      <FilterItem
        terms={terms}
        updateTerms={updateTerms}
        title={I18n.t("CourseOver language")}
        values={{
          attr: "lang",
          items: ["de", "en"],
        }}
        className="col-12"
        open={open === "initial" ? "close" : open}
      />

      <FilterItem
        terms={terms}
        updateTerms={updateTerms}
        title={I18n.t("CourseOver form")}
        values={{
          attr: "form",
          items: ["full", "coop", "indepth", "work"],
        }}
        className="col-12"
        open={open === "initial" ? "close" : open}
      />
    </div>
  );

  return (
    <>
      <FilterItems />
      <div className="d-flex justify-content-start py-3 flex-column flex-sm-row">
        <button
          className="btn bg-white"
          onClick={() => setOpen(open !== "open" ? "open" : "close")}
        >
          {I18n.t(`CourseOver ${open !== "open" ? "open" : "close"} filter`)}
          {open === "open" && <i className="las la-angle-up ms-2"></i>}
          {open !== "open" && <i className="las la-angle-down ms-2"></i>}
        </button>
        <button
          className="btn bg-white ms-0 ms-sm-3 mt-2 mt-sm-0"
          type="reset"
          onClick={() => updateTerms(null, null, true)}
        >
          {I18n.t("CourseOver reset filter")}
          <i className="las la-redo-alt ms-2"></i>
        </button>
        <a
          className="btn bg-blue ms-0 ms-sm-3 mt-2 mt-sm-0"
          onClick={() => scrollTo()}
        >
          Filtern
        </a>
      </div>
    </>
  );
};

const mapping = courseDetailsMapping();
export const FilteredBadges = ({ terms, updateTerms }) => {
  if (isEmpty(terms)) return null;

  return (
    <div className="filtered-badges d-flex flex-wrap gap-2 mb-3">
      {Object.keys(terms).map((key) => {
        const values = terms[key];
        return values.map((value) => (
          <button
            key={key + value}
            className="badge bg-blue"
            onClick={() => {
              updateTerms(key, value);
            }}
          >
            {mapping[value]} &times;
          </button>
        ));
      })}
    </div>
  );
};
